export const branding_theme = {
  primary: '#E32652',
  bg_dark: '#BF9000',
  bg_light: '#FFFFFF',
  background: '#000000',
  neutral_900: '#262626',
  neutral_800: '#434343',
  neutral_700: '#555555',
  neutral_600: '#7B7B7B',
  neutral_500: '#9D9D9D',
  neutral_400: '#9B9CA3',
  neutral_300: '#B4B5BA',
  neutral_200: '#E9E9E9',
  neutral_white: '#FFFFFF',
  neutral_black: '#000000',
  alert_error: '#EF4444',
  alert_warning: '#FB923C',
  alert_success: '#22C55E',
  neutral_alpha_8: '#FFFFFF14',
  neutral_alpha_10: '#FFFFFF1A',
  neutral_alpha_20: '#FFFFFF33',
  neutral_alpha_30: '#FFFFFF4D',
  neutral_alpha_40: '#FFFFFF66',
  neutral_alpha_50: '#FFFFFF80',
  neutral_alpha_55: '#0000008C',
  neutral_alpha_60: '#FFFFFF99',
  neutral_alpha_70: '#FFFFFFB2',
  neutral_alpha_80: '#FFFFFFCC',
  transparent: '#00000000',
  button_text: '#111D5E',
  primary_gradient: '#FFB647',
  primary_border: '#FFD799',
};

export const font_config = {
  primary_font: '"Poppins", sans-serif',
  secondary_font: '"Big Shoulders", sans-serif',
};
